import { BASE_URL } from "./constants";
import axios from "axios";
import { toast } from "react-toastify";

const API = axios.create({
  baseURL: `${BASE_URL}/`
});

// Add a request interceptor
API.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = token;
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error.error);
  }
);

// Add a response interceptor
API.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response.data.data;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.config.url !== "dev/auth"
    ) {
      localStorage.removeItem("token");
      toast.error("Session Expire");
      window.location.reload();
    }

    // Handle for multiple errors
    if (!error.response) {
      return Promise.reject("Something went wrong!");
    } else if (error.response.data?.errors) {
      return Promise.reject(error.response.data);
    } else if (error?.response?.status === 403 || error?.response?.data?.msg) {
      return Promise.reject(error.response.data.msg);
    } else if (error?.response?.data?.message) {
      return Promise.reject(error.response.data.message);
    } else {
      return Promise.reject(error.response.data.error);
    }
  }
);

export { API };
